<template>
	<div class="wrap" ref="activeModal">
		<div class="content" :style="{backgroundColor: atBgColor}">
			<div class="shareTop">
				<img src="~assets/images/makeImages/logo.png" alt="">
				<div class="topTxt">
					<p>233小游戏</p>
					<p>这里是slogan或者其他信息或者其他信息或者其他信息，最多一行。</p>
				</div>
				<div class="topBtn" @click.stop="downloadApk">立即下载</div>
			</div>
			<div class="contentBg">
				<img :src="tBgImage" alt="">
				<div class="gradientMask"></div>
			</div>
			<div class="main" :style="{paddingTop: mainPaddingTop}">
				<div class="shareInf">
					<div class="infBox">
						<div class="userInf">{{userName}}预约《{{gameInf.displayName}}》抽奖</div>
						<div class="invitation">邀你参加</div>
						<div class="itemBox">
							<div class="item" v-for="item in wheelArr" :key="item.awardId">
								<img :src="item.icon" alt />
								<p>{{item.shortName == '现金' || item.shortName == '金币' ? item.shortName == '现金' ? item.awardQuantity / 100 + '元': item.awardQuantity : ''}}{{item.shortName}}{{item.awardQuantity > 1 && item.shortName != '现金' && item.shortName != '金币' ? item.awardQuantity : ''}}</p>
							</div>
						</div>
						<div class="join" @click="clickJoin">我要参加</div>
					</div>
				</div>
				<Welfare ref="welfare" :sourceStr="sourceStr"></Welfare>
				<Introduce :sourceStr="sourceStr" :gameId="$route.query.gameId" @setGameInf="setGameInf"></Introduce>
			</div>
		</div>
		<div class="maskLoading" v-show="maskLoading">
			<img src="~assets/images/load.svg" alt />
		</div>
		<div class="mask" v-show="showMask">
			<div class="maskBox">
				<div class="closeMask" @click.stop="showMask = false"><img src="~assets/images/makeImages/close.png" alt=""></div>
				<div class="sucessMain">
					<div class="bigTit">提示</div>
					<p>你未下载233{{source == 'sg' ? '小游戏' : '乐园'}}，请点击去下载</p>
					<div class="clickBtn" @click.stop="downloadApk">去下载</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import config from "@/../config";
import active from '@/utils/axios/index'
import qs from 'qs'
import Welfare from "components/makeModal/welfare"; //预约福利
import Introduce from "components/makeModal/introduce"; //游戏介绍
export default {
	name: 'share',
	data() {
		return {
			atBgColor: '#fff', //页面背景颜色
			tBgImage: '', //页面头部的背景图片
			mainPaddingTop: '2.6rem',
			sourceStr: 'isShare', //告诉子组件是哪里引入
			maskLoading: true, //页面加载loading
			activityId: '', //活动id
			wheelArr: [], //剔除谢谢参与的所有奖品
			uuid:'',//每个客户端的uuid
			descProp: [], //预约福利
			awardDesc: '', //描述
			gameInf: {}, //游戏介绍信息
			gameId: '', //游戏id
			userName: '', //用户名
			showMask: false,
			source: '', //分享来源 pd 233乐园，sg 233小游戏
		}
	},
	components: {
		Welfare,
		Introduce
	},
	mounted() {
		this.activityId = this.$route.query.activityId;
		this.uuid = this.$route.query.uuid;
		this.gameId = this.$route.query.gameId;
		this.userName = this.$route.query.userName;
		this.source = this.$route.query.source;
		this.entry();
	},
	methods: {
		//页面初始化渲染
		entry() {
			active.entry(config.API_HOST + "/apiserv/api/activity/entry",qs.stringify({ 
				id: this.activityId 
			})).then((res) => {
				this.maskLoading = false;
				if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
				}
				document.title = res.data.activityClient.productName; //活动题目
				this.tBgImage = res.data.activityClient.topImage; //背景图片
				res.data.contentShow.forEach( item => {
					let strArr = item.split('_');
					if(strArr[0] == 'subscribe'){
						// this.subscribeInfo(strArr[1]);
						this.$refs.welfare.subscribeInfo(strArr[1]);
					}
					if(strArr[0] == 'wheel'){
						this.getWheel(strArr[1]);
					}
				});
			}).catch((error) => {
				this.maskLoading = false;
				this.$toast('网络不稳定，请稍后');
			});
		},
		//获取所有抽奖奖品
		getWheel(awardIdPointer){
			active.getWheel(config.API_HOST +'/apiserv/api/award/getWheel', {
				awardIdPointer: awardIdPointer,
				uuid: this.uuid,
				activityId: this.activityId
			}).then((res) => {
				if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
				}
				for(let i = 0; i < res.data.wheelList.length; i++){
					if(res.data.wheelList[i].shortName != '谢谢参与') {
						this.wheelArr.push(res.data.wheelList[i]);
					}
				}
			}).catch((error) => {
				this.$toast('网络不稳定，请稍后');
			});
		},
		//接收子组件游戏信息
		setGameInf(inf) {
			this.gameInf = inf;
		},
		//我要参加
		clickJoin() {
			if (this.source == 'sg') {
				window.location.href = 'f4q98x://'; //通过协议唤起app
			} else if (this.source == 'pd') {
				window.location.href = 'metaapp://233xyx'; //通过协议唤起233乐园
			}
			let openApk = setTimeout(_ => {
				this.showMask = true;
			}, 500);
			window.addEventListener('visibilitychange', () => {
				var isHidden = document.hidden;
				if (isHidden) {
					clearTimeout(openApk);
				}
			});
		},
		//跳转下载
		downloadApk() {
			if (this.source == 'sg') {
				window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.meta.xyx';
			} else if (this.source == 'pd') {
				window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.meta.box';
			}
		}
	}
}
</script>

<style scoped="scoped">
	.wrap{
		width: 100%;
		height: 100%;
		overflow-y: scroll;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		overflow-scrolling: touch;
	}
	.wrap::-webkit-scrollbar {display:none}
	.content{
		background-repeat: no-repeat;
		background-position: top;
		background-size: contain;
		padding-bottom: 0.1rem;
		position: relative;
	}
	.main{
		position: relative;
		z-index: 3;
	}
	.shareInf{
		padding: 0 0.14rem;
	}
	.infBox{
		background-image: linear-gradient(180deg, #FFEECC 0%, #FFFFFF 45%);
		border-radius: 0.12rem;
		box-shadow: 0 0.02rem 0.16rem 0 rgba(0,0,0,0.08);
		background-color: #fff;
		padding: 0.25rem;
		text-align: center;
	}
	.userInf{
		font-size: 0.14rem;
		color: #E68600;
	}
	.invitation{
		font-size: 0.18rem;
		color: #E68600;
		margin-top: 0.07rem;
		font-weight: bold;
	}
	.itemBox{
		display: flex;
		flex-wrap: wrap;
		background: #FFFAEB;
		border-radius: 0.12rem;
		padding: 0.1rem 0.05rem;
		margin-top: 0.1rem;
	}
	.item{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 25%;
	}
	.item img{
		width: 0.48rem;
		height: 0.48rem;
		border-radius: 0.06rem;
	}
	.item p{
		font-size: 0.12rem;
		color: #1C1C1C;
		margin-top: 0.05rem;
	}
	.join{
		background: #FF9500;
		border-radius: 0.28rem;
		height: 0.4rem;
		line-height: 0.4rem;
		text-align: center;
		color: #FFFFFF;
		font-size: 0.15rem;
		margin-top: 0.2rem;
	}
	.contentBg{
		position: absolute;
		top: 0.5rem;
		left: 0;
	}
	.contentBg img{
		width: 100%;
		height: auto;
	}
	.gradientMask{
		width: 100%;
		height: 100%;
		background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 0%, #FFFFFF 100%);
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
	}
	.shareTop{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 0.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 4;
		background-color: #fff;
	}
	.shareTop img{
		width: 0.34rem;
		height: 0.34rem;
	}
	.topTxt{
		margin: 0 0.1rem;
		width: 2.2rem;
	}
	.topTxt p{
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.topTxt p:first-child{
		font-size: 0.14rem;
		color: #333333;
		font-weight: bold;
	}
	.topTxt p:last-child{
		font-size: 0.11rem;
		color: #999999;
	}
	.topBtn{
		width: 0.74rem;
		height: 0.3rem;
		line-height: 0.3rem;
		text-align: center;
		background: #FF9500;
		border-radius: 0.16rem;
		font-size: 0.12rem;
		color: #FFFFFF;
	}
	.maskLoading {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 999;
		background: rgba(189, 84, 28, 0.98);
		display: flex;
		justify-content: space-around;
		align-items: center;
	}
	.maskLoading img {
		display: block;
		width: 0.4rem;
		height: 0.4rem;
		animation: loading 2s linear 0s infinite;
	}
	@keyframes loading {
		from {
			transform: rotate(0);
		}
	
		to {
			transform: rotate(360deg);
		}
	}
	.welfare{
		margin-top: 0.08rem;
		padding: 0.2rem 0.14rem;
	}
	.welfare .tit{
		font-size: 0.18rem;
		color: rgba(255,255,255,0.90);
	}
	.welfareContent{
		display: flex;
		flex-wrap: wrap;
		margin-top: 0.1rem;
	}
	.welfareMain{
		width: 25%;
		padding: 0.03rem;
	}
	.wfTtemMain{
		/* padding: 0.03125rem; */
		width: 100%;
		height: 0;
		padding-top: 100%;
		position: relative;
	}
	.welfareItem{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 100%;
		height: 100%;
		background-color: rgba(255,255,255,0.05);
		border-radius: 0.08rem;
		position: absolute;
		top: 0;
		left: 0;
	}
	.welfareItem img{
		width: 0.38rem;
		height: 0.38rem;
		border-radius: 0.04rem;
	}
	.welfareItem p{
		color: rgba(255,255,255,0.87);
		font-size: 0.12rem;
		margin-top: 0.05rem;
	}
	.welfareTxt{
		color: rgba(255,255,255,0.60);
		font-size: 0.14rem;
		margin-top: 0.1rem;
	}
	.sourceShare .tit{
		color: #333;
		font-weight: bold;
	}
	.sourceShare .welfareItem{
		background-color: #F5F5F5;
	}
	.sourceShare .welfareItem p{
		color: #333;
	}
	.sourceShare .welfareTxt{
		color: #666666;
	}
	.introduce{
		margin-top: 0.08rem;
		padding: 0.2rem 0 0.2rem 0.14rem;
	}
	.introduce .tit{
		color: rgba(255,255,255,0.9);
		font-size: 0.18rem;
	}
	.introduceMain{
		overflow-y: hidden;
		overflow-x: scroll;
		white-space: nowrap;
		font-size: 0;
		-webkit-overflow-scrolling: touch;
		margin-top: 0.13rem;
	}
	.introduceMain::-webkit-scrollbar {display:none}
	.introduceMain .item{
		width: 1.44rem;
		height: 2.4rem;
		margin-right: 0.08rem;
		border-radius: 0.08rem;
		overflow: hidden;
	}
	.introduceMain .item:last-child{
		margin-right: 0;
	}
	.videowrap{
		display: inline-block;
		vertical-align: top;
	}
	.videowrap .video-js{
		width: 100%;
		height: 100%;
	}
	.imgItem{
		display: inline-block;
		vertical-align: top;
	}
	.imgItem img{
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	.introduceTxt{
		overflow: hidden;
		/* display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3; */
		width: 100%;
		font-size: 0.14rem;
		padding-right: 0.14rem;
		color: rgba(255,255,255,0.60);
		position: relative;
		margin-top: 0.15rem;
	}
	.introduceTxt span{
		position: absolute;
		right: 0.18rem;
		bottom: 0;
		color: #FF9500;
		font-size: 0.14rem;
	}
	.sourceShare{
		margin-top: 0;
		padding-top: 0.08rem;
	}
	.sourceShare .tit{
		color: #333333;
		font-weight: bold;
	}
	.sourceShare .introduceTxt{
		color: #666666;
	}
	.mask{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.75);
		z-index: 151;
	}
	.maskBox{
		width: 2.8rem;
		height: auto;
		background-color: #fff;
		border-radius: 0.12rem;
		padding-top: 0.17rem;
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		overflow: hidden;
	}
	.maskBox p{
		font-size: 0.14rem;
		color: #666666;
		margin-top: 0.06rem;
	}
	.sucessMain{
		padding: 0 0.2rem 0.2rem;
		text-align: center;
	}
	.bigTit{
		font-size: 0.19rem;
		color: #333333;
		text-align: center;
		font-weight: bold;
	}
	.clickBtn{
		background-color: #FF9500;
		border-radius: 0.22rem;
		font-size: 0.15rem;
		color: #FFFFFF;
		height: 0.44rem;
		line-height: 0.44rem;
		margin-top: 0.2rem;
	}
	.closeMask{
		text-align: right;
		font-size: 0;
		padding: 0 0.17rem;
		position: relative;
		z-index: 152;
	}
	.closeMask img{
		width: 0.16rem;
		height: 0.16rem;
	}
</style>
